const state = {
    after_sales: [],
    itens: [],
    item: {
        id: null,
        name: '',
        module_id: '',
        functionalities: [],
        module: {
            id: null,
            name: '',
            icon: ''
        }
    },
    managers: [],
    salesmans: [],
    supervisors: []
};

export default state;